"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.todayString = exports.timestampStringInEnglishFromDate = exports.timestampStringInEnglish = exports.timestampStringFromDate = exports.timestampString = exports.parseDayString = exports.getDateDifference = exports.dayString = void 0;
const todayString = (separator = "-") => dayString(new Date(), separator);
exports.todayString = todayString;
const dayString = (date, separator = "-") => {
  return `${date.getFullYear()}${separator}${String(date.getMonth() + 1).padStart(2, '0')}${separator}${String(date.getDate()).padStart(2, '0')}`;
};
exports.dayString = dayString;
const timestampString = (separator = "-") => {
  var d = new Date();
  return `${d.getFullYear()}${separator}${String(d.getMonth() + 1).padStart(2, '0')}${separator}${String(d.getDate()).padStart(2, '0')}${separator}${String(d.getHours()).padStart(2, '0')}${separator}${String(d.getMinutes()).padStart(2, '0')}${separator}${String(d.getSeconds()).padStart(2, '0')}${separator}${String(d.getMilliseconds()).padStart(3, '0')}`;
};
exports.timestampString = timestampString;
const timestampStringInEnglish = timestampString => {
  var _timestampString$subs, _timestampString$subs2, _timestampString$subs3, _timestampString$subs4, _timestampString$subs5;
  //const d = new Date();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthIdx = parseInt((_timestampString$subs = timestampString === null || timestampString === void 0 || (_timestampString$subs2 = timestampString.substring) === null || _timestampString$subs2 === void 0 ? void 0 : _timestampString$subs2.call(timestampString, 5, 7)) !== null && _timestampString$subs !== void 0 ? _timestampString$subs : 1);
  const month = monthNames[monthIdx - 1];
  const day = String(timestampString === null || timestampString === void 0 || (_timestampString$subs3 = timestampString.substring) === null || _timestampString$subs3 === void 0 ? void 0 : _timestampString$subs3.call(timestampString, 8, 10)).padStart(2, '0');
  const year = (_timestampString$subs4 = timestampString === null || timestampString === void 0 || (_timestampString$subs5 = timestampString.substring) === null || _timestampString$subs5 === void 0 ? void 0 : _timestampString$subs5.call(timestampString, 0, 4)) !== null && _timestampString$subs4 !== void 0 ? _timestampString$subs4 : "2024";
  return `${month} ${day}, ${year}`;
};
exports.timestampStringInEnglish = timestampStringInEnglish;
const timestampStringInEnglishFromDate = (d, separator = "-") => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[d.getMonth()];
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();
  return `${month} ${day}, ${year}`;
};
exports.timestampStringInEnglishFromDate = timestampStringInEnglishFromDate;
const timestampStringFromDate = (date, separator = "-") => {
  return `${date.getFullYear()}${separator}${String(date.getMonth() + 1).padStart(2, '0')}${separator}${String(date.getDate()).padStart(2, '0')}${separator}${String(date.getHours()).padStart(2, '0')}${separator}${String(date.getMinutes()).padStart(2, '0')}${separator}${String(date.getSeconds()).padStart(2, '0')}${separator}${String(date.getMilliseconds()).padStart(2, '0')}`;
};
exports.timestampStringFromDate = timestampStringFromDate;
const parseDayString = (day, separator = "-") => {
  var d = new Date();
  const parts = day.split(separator);
  d.setFullYear(parseInt(parts[0]));
  d.setMonth(parseInt(parts[1]) - 1);
  d.setDate(parseInt(parts[2]));
  return d;
};
exports.parseDayString = parseDayString;
const getDateDifference = (day1, day2, separator = "-") => {
  return Math.abs(Math.ceil((parseDayString(day2).getTime() - parseDayString(day1).getTime()) / (1000 * 60 * 60 * 24)));
};
exports.getDateDifference = getDateDifference;